export const getLocationPath = state => state.routing.location.pathname
export const getMainRoute = state => state.routes.trackedRoutes.main
export const getSubRoute = (state, route) => state.routes.trackedRoutes[route]

export const isSubRouteActive = (state, mainRoute, subRoute) =>
    getMainRoute(state) === mainRoute &&
    getSubRoute(state, mainRoute) === subRoute

export const isSalesBoardVisible = (state, boardUrl) => isSubRouteActive(state, 'sales', boardUrl)
export const isLeadsBoardVisible = state => isSalesBoardVisible(state, '/leads')
export const isSellingBoardVisible = state => isSalesBoardVisible(state, '/selling')
export const isWonBoardVisible = state => isSalesBoardVisible(state, '/won')
